import {
  calcDrawableChartMode,
  calcQuestionChartMode,
  WC_CHART_MODE
} from '@aytm/app/stats/page/question-views/components/lib/chart-modes'

export const hasBase = answer => {
  if (!answer) return false

  if (Object.hasOwn(answer, 'base')) return true

  return Object.keys(answer).some(key => answer[key] != null && Object.hasOwn(answer[key], 'base'))
}

export const getChartModeTypes = ({
  answer,
  percentsOnly = false,
  isRType = false,
  isTraitType = false,
  trait = null
}) => {
  const answerHasBase = hasBase(answer)

  if (answerHasBase || percentsOnly) {
    return ['percents', 'bpercents']
  }

  if (isRType || (isTraitType && trait != null)) {
    return ['respondents', 'percents', 'brespondents', 'bpercents']
  }

  return ['pie', 'respondents', 'percents', 'brespondents', 'bpercents']
}

// the type's own rules; the exported resolver then fits the result to the modes the question offers
const calcPreferredChartMode = ({
  chartMode,
  questionChartMode,
  globalChartMode,
  answer,
  percentsOnly = false,
  isRType = false
}) => {
  const answerHasBase = hasBase(answer)

  let mode = calcQuestionChartMode(chartMode, questionChartMode, globalChartMode)

  if (isRType && mode === 'pie') {
    mode = 'respondents'
  }

  if ((answerHasBase || percentsOnly) && !['percents', 'bpercents'].includes(mode)) {
    return 'percents'
  }

  return mode
}

// the word cloud is drawn by the block itself, so it is kept rather than fitted to a chart
export const getDefaultChartMode = args =>
  calcDrawableChartMode(calcPreferredChartMode(args), getChartModeTypes(args), {
    globalChartMode: args.globalChartMode,
    keep: [WC_CHART_MODE]
  })
